var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFbIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "fb-icon",
    xmlns: "http://www.w3.org/2000/svg",
    width: 8.228,
    height: 15.796,
    viewBox: "0 0 8.228 15.796",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Black",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Facebook_1_",
    d: "M224.595,183.1v-7.219H227l.349-2.794h-2.794V171.3c0-.815.233-1.358,1.4-1.358h1.475v-2.523a18.289,18.289,0,0,0-2.173-.116,3.4,3.4,0,0,0-3.609,3.726v2.057H219.2v2.794h2.445V183.1h2.95Z",
    transform: "translate(-219.2 -167.3)",
    fill: "#fff",
    fillRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFbIcon);
export default __webpack_public_path__ + "static/media/fb-icon.739bde7d8f39d9f134c96b9b4531b8e9.svg";
export { ForwardRef as ReactComponent };